exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-item[data-v-3f14d597]{background-color:#fff;padding:.5rem}", ""]);

// exports
